module.exports = __webpack_public_path__ + "static/media/notosans-bold.da5c0e9a.woff";